module.exports = __webpack_public_path__ + "static/pemalex_img_malharia_v-4dddda2b175b1a11cd64b04960a029e0.jpg";